const theme = {
  colors: {
    primary: '#D69807',
    red: '#A7383E',
    green: '#315B14',
    light: '#ffffff',
    dark: '#000000',
    grey: '#8D8C8C',
    lightgrey: '#CBCBCB',
    shadow: 'rgba(0, 0, 0, 0.2)'
  },
  greenFilter:
    'brightness(0%) saturate(100%) invert(23%) sepia(97%) saturate(405%) hue-rotate(52deg) brightness(101%) contrast(89%)'
};

export default theme;
